import { createFileRoute } from "@tanstack/react-router";

import HighlightsCategoryContent from "../-components/$categoryId";

export const Route = createFileRoute("/_authenticated/$alias/settings/highlights/$categoryId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { categoryId } = Route.useParams();
  return <HighlightsCategoryContent categoryId={categoryId} />;
}
